import validator from "validator";

const customEmailValidator = (_, value) => {
  if (!value) {
    return Promise.reject("Email is required");
  }

  if (!validator.isEmail(value)) {
    return Promise.reject("Invalid email format");
  }

  const domain = value.split("@")[1];

  const domainParts = domain.split(".");
  if (domainParts.length < 2 || domainParts.some((part) => part.length < 2)) {
    return Promise.reject("Invalid email format");
  }

  if (value.includes("..")) {
    return Promise.reject("Invalid email format");
  }

  if (domainParts[0].length === 1) {
    return Promise.reject("Invalid email format");
  }

  if (domainParts.length > 2) {
    return Promise.reject("Invalid email format");
  }

  return Promise.resolve();
};

export {
  customEmailValidator,
};
